import './user.less';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import RankPopup from './components/rank-popup';
import cn from 'classname';

import Avatar from '../../../../modules/shared/avatar';
import pubDefaultAva from '../../assets/img/global/default-avatars/web_80x80.png';

const propTypes = {
	userData: PropTypes.object,
	location: PropTypes.object,
	intl: PropTypes.func,
	logout: PropTypes.func
};

const User = ({ userData, logout, intl, location }) => {
	const isRanksPage = location.pathname && location.pathname.includes('ranks');
	return (
		<div
			className={cn({'top-user-control': true, 'is-on-ranks': isRanksPage})}
			onClick={() => { browserHistory.push('profile');}}
		>
			<a className="user font-proxima-nova-semibold">
				<span className="user__wrap">
					<Avatar className='user__avatar' src={userData.general.avatar || pubDefaultAva}  />
					<span className="user__name">
						{ userData.general.nickname ? userData.general.nickname : userData.general.email }
					</span>
				</span>
				<RankPopup intl={intl} />
			</a>
			<span className="user__logout" onClick={logout} />
		</div>
	);
};

User.propTypes = propTypes;

export default connect(
	state => ({ userData: state.app.userData })
)(User);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/top/user.js